<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>停服公告配置{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="开始时间" prop="stime">
            <el-date-picker v-model="formData.stime" style="width: 300px" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" />
          </el-form-item>
          <el-form-item label="结束时间" prop="etime">
            <el-date-picker v-model="formData.etime" style="width: 300px" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" />
          </el-form-item>
          <el-form-item label="停服状态" prop="type">
            <el-select v-model.number="formData.type" placeholder="请选择">
              <el-option
                v-for="item in statusType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型" prop="device">
            <el-select v-model.number="formData.device" placeholder="请选择">
              <el-option
                v-for="item in deviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型" prop="usertype">
            <el-select v-model.number="formData.usertype" placeholder="请选择">
              <el-option
                v-for="item in usertypeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="白名单" prop="wlist" rows="5">
            <el-select
              v-model="formData.wlist"
              style="width: 1000px"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入用户UID"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in users"
                :key="item.value"
                :label="item.nick"
                :value="item.uid"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="黑名单" prop="blist" rows="5">
            <el-select
              v-model="formData.blist"
              style="width: 1000px"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入用户UID"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in users"
                :key="item.value"
                :label="item.nick"
                :value="item.uid"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="语言" prop="langs">
            <el-select v-model="formData.langs" style="width: 1200px" multiple placeholder="请选择">
              <el-option
                v-for="(item, index) in lang"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
            <el-upload
              ref="upload"
              style="display: inline-block"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res)}"
              :headers="headers"
            >
              <el-button style="margin-left: 10px" :loading="loading" icon="el-icon-upload2" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item prop="title">
            <el-form :inline="true">
              <el-row v-for="(l, li) in formData.langs" :key="li">
                <el-form-item :label="lang[l]+'内容'" style="margin-top: 8px;">
                  <el-input
                    v-model="formData.content[l]"
                    placeholder="请输入内容"
                    style="width: 980px;"
                  />
                </el-form-item>
              </el-row>
            </el-form>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { importGameUpdateLang } from '@/api/config/game-update-cfg'
import { getAnnouncementList, updateAnnouncementCfg } from '@/api/config/announcement-cfg'
import { searchUid } from '@/api/user/user_info'

export default {
  name: 'AnnouncementEdit',
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      total: 0,
      statusType: [{ label: '停服,白名单可以玩', value: 3 }, { label: '停服', value: 2 }, { label: '不停服', value: 1 }],
      deviceType: [
        { label: '全部', value: 0 },
        { label: '安卓', value: 1 },
        { label: 'IOS', value: 2 }
      ],
      usertypeType: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'fb', value: 1 }],
      users: [],
      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'TW': '繁 体',
        'FR': '法 语',
        'DE': '德 语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'TH': '泰 语',
        'VN': '越 南',
        'NO': '挪 威',
        'ID': '印 尼',
        'IT': '意大利',
        'MY': '马来西亚',
        'RO': '罗马尼亚'
      },
      loading: false,
      formData:
        {
          id: 0,
          title: '',
          content: [],
          stime: '',
          etime: '',
          device: 0,
          usertype: 0,
          type: 1,
          wlist: '',
          blist: '',
          isvalid: 0,
          announce_type: 0,
          langs: []
        },
      rules: {}
    }
  },
  created() {
    const id = this.$route.query.id
    console.log(id)
    if (id > 0) {
      this.getTables(id)
    }
  },
  methods: {
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGameUpdateLang({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.formData.langs = res.data.lang
          this.formData.title = res.data.title
          this.formData.content = res.data.body
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(id) {
      getAnnouncementList({ id: id }).then(res => {
        if (res.code === 200) {
          const data = res.data.list[0]
          this.$set(data, 'langs', [])
          for (const i in data.content) {
            data.langs.push(i)
          }
          this.formData = data
          console.log('this.formData', this.formData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          if (!_data.stime) {
            this.msgError('请选择开始时间')
            return
          }
          if (!_data.etime) {
            this.msgError('请选择结束时间')
            return
          }
          if (_data.stime > _data.etime) {
            this.msgError('开始时间不能大于结束时间')
            return
          }

          if (this.formData.langs.length > 0) {
            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _content = this.formData.content[_lang]
              if (_content === '' || _content === undefined) {
                this.msgError('内容 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }
          }
          const newObj = Object.assign({}, this.formData)
          const content = {}
          for (const i in this.formData.langs) {
            const lKey = this.formData.langs[i]
            content[lKey] = this.formData.content[lKey]
          }
          newObj.title = ''
          newObj.content = content
          const data = JSON.stringify(newObj)
          console.log('data', data)
          updateAnnouncementCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/announcement/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data
        })
      } else {
        this.users = []
      }
    }
  }
}
</script>

<style scoped>
</style>
